import { FunctionComponent } from 'react';
import { useApplicationMachine } from './useApplicationMachine';

export const ApplicationSubscriber: FunctionComponent = () => {
  const { state } = useApplicationMachine();
  const estimatedSpendMachineContext =
    state.context.stateMachineActorRefs.estimatedSpendMachineActorRef?.getSnapshot()
      .context;

  const fraudAlloyMachineSnapshot =
    state.context.stateMachineActorRefs.fraudAlloyMachineActorRef?.getSnapshot();

  const paymentsMachineSnapshot =
    state.context.stateMachineActorRefs.paymentsMachineActorRef?.getSnapshot();

  return (
    <pre className="text-sm">
      {JSON.stringify({ value: state.value }, null, 2)}
      {JSON.stringify({ value: state?.context }, null, 2)}
      {JSON.stringify({ value: estimatedSpendMachineContext }, null, 2)}
      {JSON.stringify({ value: fraudAlloyMachineSnapshot?.value }, null, 2)}
      {JSON.stringify({ value: fraudAlloyMachineSnapshot?.context }, null, 2)}
      {JSON.stringify({ value: paymentsMachineSnapshot?.value }, null, 2)}
      {JSON.stringify({ value: paymentsMachineSnapshot?.context }, null, 2)}
    </pre>
  );
};
